module.exports = __webpack_public_path__ + "static/media/right-arrow.e57f0949.svg";